import React from "react";
import SupportLayout from "../support/SupportLayout";
import ProgressContent from "./components/ProgressContent";
import useSupportOfficerData from "./hooks/useSupportOfficerData";

const SupportOfficerProgress = () => {
  const {
    progressData,
    loading,
    getDefaultDates,
    fetchProgressDashboard,
    orders,
    pagination,
    fetchOrders,
  } = useSupportOfficerData();

  return (
    <SupportLayout userRole="SO">
      <ProgressContent
        useOwnLayout={true}
        showFilter={false}
        externalData={progressData}
        externalLoading={loading}
        externalGetDefaultDates={getDefaultDates}
        externalFetchData={fetchProgressDashboard}
        externalFetchOrders={fetchOrders}
        externalOrders={orders}
        externalPagination={pagination}
        userRole="SO"
      />
    </SupportLayout>
  );
};

export default SupportOfficerProgress;
